import * as Sentry from '@sentry/react'

const dsn = process.env.REACT_APP_SENTRY_DSN
const isProduction = process.env.NODE_ENV === 'production'

if (dsn && isProduction) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    ignoreErrors: [
      /Java object is gone/,
      /^TypeError: Load failed$/,
    ],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/(www\.)?lifesportsclub\.net\/api/,
    ],
  })
}

export default Sentry
